import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Layout } from './components/layout';
import { Dashboard } from './pages/Dashboard';
import { Activities } from './pages/Activities';
import { Essays } from './pages/Essays';
import { Research } from './pages/Research';
import { AIHub } from './pages/AIHub';
import { ThemeBuilderPage } from './pages/ThemeBuilder';
import { Roadmap } from './pages/Roadmap';
import { Advisors } from './pages/Advisors';
import { UniversityInsightsPage } from './pages/UniversityInsights';
import { BrandAnalyzerPage } from './pages/BrandAnalyzer';
import { AdmissionCalculatorPage } from './pages/AdmissionCalculator';
import { TrendsTrackerPage } from './pages/TrendsTracker';
import { InterviewPrepPage } from './pages/InterviewPrep';
import { FamilyCollaborationPage } from './pages/FamilyCollaboration';
import { Portfolio } from './pages/Portfolio';
import { Academics } from './pages/Academics';
import { Goals } from './pages/Goals';
import { Colleges } from './pages/Colleges';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ProtectedRoute>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/ai-hub" element={<AIHub />} />
              <Route path="/activities" element={<Activities />} />
              <Route path="/essays" element={<Essays />} />
              <Route path="/research" element={<Research />} />
              <Route path="/theme-builder" element={<ThemeBuilderPage />} />
              <Route path="/advisors" element={<Advisors />} />
              <Route path="/university-insights" element={<UniversityInsightsPage />} />
              <Route path="/brand-analyzer" element={<BrandAnalyzerPage />} />
              <Route path="/admission-calculator" element={<AdmissionCalculatorPage />} />
              <Route path="/trends-tracker" element={<TrendsTrackerPage />} />
              <Route path="/interview-prep" element={<InterviewPrepPage />} />
              <Route path="/family-collaboration" element={<FamilyCollaborationPage />} />
              <Route path="/academics" element={<Academics />} />
              <Route path="/goals" element={<Goals />} />
              <Route path="/colleges" element={<Colleges />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/roadmap" element={<Roadmap />} />
            </Routes>
          </Layout>
        </ProtectedRoute>
      </Router>
    </AuthProvider>
  );
}

export default App;
